import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei from "Types/IMei";
import { State } from "store/reducers";

export const CREATE_MEI = "[MEI CREATE] CREATE_MEI";
export const CREATE_MEI_SUCCESS = "[MEI CREATE] CREATE_MEI_SUCCESS";
export const CREATE_MEI_FAILED = "[MEI CREATE] CREATE_MEI_FAILED";

export const SET_VALUE = "[MEI CREATE] SET_VALUE";
export const CLEAR_VALUES = "[MEI CREATE] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createMei(callback: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_MEI });

		try {
			const { login, meiCreate } = getState() as State;

			const { businessName, logisticOperator, logisticOperatorStatus } =
				meiCreate;

			const errors: any = {};

			dispatch(setValue({ errors }));

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

			const model = {
				logisticOperator,
				logisticOperatorStatus
			};

			const response = await api.sendPost("/Mei", model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: CREATE_MEI_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_MEI_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_MEI_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
